import { useQuery } from '@tanstack/react-query';
import {
  customerBillingService,
  type NextInvoicePreview,
} from '@app/shared/services/customer-billing.service';
import { useHasPermission } from '@app/shared/hooks/permission.hook';

/**
 * Server-side single source of truth for the caller's next
 * subscription invoice. Wraps GET /billing/me/next-invoice-preview.
 *
 * Consumers (PaymentsHistorySection synthetic next-payment row,
 * account "Próximo cobro" card) render this response directly —
 * pricing / discount / totals / renewal date all computed by
 * BillingService.computeNextInvoicePreview on the backend so the
 * FE cannot drift away from what the recurring cron actually bills.
 */
export const NEXT_INVOICE_PREVIEW_KEY = ['my-next-invoice-preview'] as const;

export const useMyNextInvoicePreview = () => {
  // GET /billing/me/next-invoice-preview is `billing.self.manage`-gated
  // server-side; don't fire for a role without it or it 403s.
  const canReadBilling = useHasPermission('billing.self.manage');
  return useQuery<NextInvoicePreview>({
    queryKey: NEXT_INVOICE_PREVIEW_KEY,
    queryFn: () => customerBillingService.getNextInvoicePreview(),
    staleTime: 30 * 1000,
    enabled: canReadBilling,
  });
};
